import { createRouter, createWebHistory } from 'vue-router';
import SiteLayout from "@/layout/SiteLayout.vue";

const router = createRouter({
    history: createWebHistory(),
    // @ts-ignore
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            const el = document.getElementById(to.hash.slice(1));
            let top = 0
            if (el) {
                const topbar = document.getElementById('site-topbar');
                top = el.offsetTop - (topbar ? topbar.clientHeight : 0);
            }
            return {
                top
            };
        } else if (savedPosition) {
            return savedPosition;
        } else {
            return { top: 0 };
        }
    },
    routes: [
        {
            path: '/',
            component: SiteLayout,
            children: [
                {
                    path: '/',
                    name: 'Home',
                    component: () => import('@/views/pages/Home.vue')
                },
                {
                    path: '/sign-up',
                    name: 'SignUp',
                    component: () => import('@/views/pages/SignUp.vue')
                },
                {
                    path: '/terms-and-conditions',
                    name: 'TermsAndConditions',
                    component: () => import('@/views/pages/TermsAndConditions.vue')
                },
                {
                    path: '/auth/login',
                    name: 'Login',
                    component: () => import('@/views/pages/auth/Login.vue')
                },
                {
                    path: '/notfound',
                    name: 'NotFound',
                    // @ts-ignore
                    component: () => import('@/views/pages/errors/NotFound.vue')
                },
                {
                    path: '/my-mailbox',
                    name: 'MyMailbox',
                    component: () => import('@/views/pages/customer/MyMailbox.vue')
                },
                {
                    path: '/link/:id',
                    name: 'LinkView',
                    props: true,
                    component: () => import('@/views/pages/LinkView.vue')
                },
            ]
        },
        { path: "/:pathMatch(.*)*", redirect: "/notfound" },
    ]
});

export default router;